import { Component, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: true,
    imports: [CommonModule, SharedModule, RouterModule],
})
export class AuthComponent {
    public isAtLeastMedium!: boolean;

    constructor() {
        inject(BreakpointObserver)
            .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                const matches = result.matches;
                this.isAtLeastMedium = matches;
            });
    }
}
